module.exports = __webpack_public_path__ + "img/1602349899.e24c8fbd.png";